<template>
  <div class="page">
    <div class="page-title">
      <span class="title">供应商加盟</span>
    </div>
    <div class="page-dec">
      <p class="dec-title">
        供应商
      </p>
      <p class="dec-content">
        以公司为行为主体，具有家居某一个或者多个行业产品安装维修需求的，在平台上输出服务订单的团体，称之为供应商
      </p>
    </div>
    <div class="page-contnet-main">
      <div class="content-item" v-for="(value, index) in decItems" :key="index">
        <img :src="value.imgUrl" alt="">
        <p>{{value.word1}}</p>
        <p>{{value.word2}}</p>
      </div>
      <el-button type="primary" class="applyBtn2" @click="join">申请加入</el-button>
    </div>
    <el-button type="primary" class="applyBtn" @click="join">申请加入</el-button>
  </div>
</template>
<script>
import { ADD_ROLE } from '@/store/role';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      decItems: [{
        imgUrl: require('@/assets/supply/plantform.png'),
        word1: '智能平台',
        word2: '快捷派单'
      }, {
        imgUrl: require('@/assets/supply/quick.png'),
        word1: '极速响应',
        word2: '无延下发'
      }, {
        imgUrl: require('@/assets/supply/return.png'),
        word1: '单单可视',
        word2: '实时回执'
      }, {
        imgUrl: require('@/assets/supply/service.png'),
        word1: '在线客服',
        word2: '全程对接'
      }, {
        imgUrl: require('@/assets/supply/teach.png'),
        word1: '成熟培训体系',
        word2: '专业技术指导'
      }, {
        imgUrl: require('@/assets/supply/data.png'),
        word1: '工单统计',
        word2: '快捷派单'
      }]
    }
  },
  methods: {
    ...mapMutations([ADD_ROLE]),
    join() {
      this.ADD_ROLE('5')
      this.$router.push({
        path: '/worker/workerInfo',
        query: {
          userType: '5'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-title{
  height: 3rem;
  position: relative;
  .title{
    line-height: 3rem;
    display: block;
    margin: 0 auto;
    color: #666666;
    font-size: 0.9rem;
    text-align: center;
  }
}
.applyBtn{
  margin-left: calc(50% - 70px);
}
  .applyBtn2{
    display: none
  }
.page-dec{
  height: 5rem;
  text-align: center;
  color: #666666;
  font-size: 0.6rem;
  .dec-title{
    height: 2rem;
    color: #333333;
    line-height: 2rem;
    margin-top: 1rem;
  }
  .dec-content{
    height: 1rem;
    line-height: 1rem;
  }
}
.page-contnet-main{
  width: 22rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .content-item{
    width: 5.58rem;
    height: 7rem;
    border: 2px solid #EE8E38;
    border-radius: 5px;
    margin-bottom: 1.1rem;
    img{
      width: 3rem;
      display: block;
      margin: 0.8rem auto;
    }
    p{
      text-align: center;
      color:rgba(51,51,51,1);
      font-size: 0.6rem;
    }
  }
}
@media screen and (max-width: 750px) {
  .page{
    width: 100%;
  }
  .page-dec{
    height: 5rem;
    padding: 0 1rem;
  }
  .page-contnet-main{
    width: 100%;
    padding: 1rem;
    text-align: center;
    .content-item{
      width: 30%;
    }
  }
  .applyBtn{
    display: none;
  }
  .applyBtn2 {
    display: block;
    margin: 0 auto;
  }
}
</style>

